import { render, staticRenderFns } from "./storeGoods.vue?vue&type=template&id=77cdc388&scoped=true&"
import script from "./storeGoods.vue?vue&type=script&lang=js&"
export * from "./storeGoods.vue?vue&type=script&lang=js&"
import style0 from "./storeGoods.vue?vue&type=style&index=0&id=77cdc388&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cdc388",
  null
  
)

component.options.__file = "storeGoods.vue"
export default component.exports